export const PageEnum = {
  DASHBOARD: "Dashboard",
  PRODUCTS: "Products",
  LISTICLES: "Listicles",
  TEMPLATES: "Templates",
  PAGES: "Pages",
  CAMPAIGNS: "Campaigns",
  REPORTS: "Reports",
  TRENDS: "Trends",
};

export const OperationType = {
  CREATE: "CREATE",
  UPDATE: "UPDATE",
};

export const RelationType = {
  INCOME: "INCOME",
  EXPENSE: "EXPENSE",
};

export const Sorting = {
  NF: "Newest First",
  OF: "Oldest First",
  AZ: "A → Z",
  ZA: "Z → A",
};

// Set by clicking a Products table header; shown in the sort dropdown but not listed as options.
export const ProductColumnSorting = {
  REV_MAX: "Revenue ↓",
  REV_MIN: "Revenue ↑",
  IMP_MAX: "Impression ↓",
  IMP_MIN: "Impression ↑",
  CR_MAX: "CR ↓",
  CR_MIN: "CR ↑",
  CTR_MAX: "CTR ↓",
  CTR_MIN: "CTR ↑",
  AI_MAX: "AI Updates ↓",
  AI_MIN: "AI Updates ↑",
};

export const EntriesFilter = {
  OVERDUE: "OVERDUE",
  PENDING: "PENDING",
  COMPLETED: "COMPLETED",
};

export const EntriesTabs = {
  Past: "Past",
  Linked: "Linked",
  Activity: "Activity",
};

export const ReportSources = {
  CAMPAIGN: "Campaigns",
  LISTICLE: "Listecles",
};

export const ReportFilter = {
  TODAY: "Today",
  YESTERDAY: "Yesterday",
  THIS_MONTH: "This Month",
  LAST_MONTH: "Last Month",
  OTHER: "Other",
};
